import { render, staticRenderFns } from "./FirmFormPanel.vue?vue&type=template&id=c6a0fe74"
import script from "./FirmFormPanel.vue?vue&type=script&lang=js"
export * from "./FirmFormPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports